import { AppBar, Toolbar, Typography, Box, Grid } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { setPrenotaNewDate, incrementRequestVersion } from '../../../redux/reducers/prenotazioneNew-reducer';
import { resetPostazioneSelectedAndInfoPostazione } from '../../../redux/reducers/prenotazioneStepper-reducer';
import GeneralCustomDateTimePicker from '../../UI/TimePicker/GeneralCustomDateTimePicker';
import { useTranslation } from 'react-i18next';
import PannelloSuggerimentiPrenotazioneNew from '../Suggestions/PannelloSuggerimentiPrenotazioneNew';
import handlerConfiguration from '../../../functions/general/handlerConfiguration';
import '../styles/HeaderPrenotaNew.css';

export default function HeaderPrenotaNew({ handleClose, isMobile }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { currentStep, selectedDate, selectedStartTime, selectedEndTime } = useSelector(state => state.prenotazioneNew);
    const configurations = useSelector(state => state.configurations);
    const { maxGiorniAnticipoPrenotazione } = handlerConfiguration(configurations);
    const now = new Date(Date.now());
    const maxday = new Date(new Date(Date.now()).setDate(now.getDate() + maxGiorniAnticipoPrenotazione));

    const handleChangeData = (newValue) => {
        if (newValue !== null) {
            dispatch(setPrenotaNewDate({ date: newValue.toString(), startTime: selectedStartTime, endTime: selectedEndTime }));
            dispatch(incrementRequestVersion());
            dispatch(resetPostazioneSelectedAndInfoPostazione());
        }
    };

    const handleChangeOrarioInizio = (newValue) => {
        if (newValue !== null) {
            let newDate = staticDateWithTimeValue(newValue);
            dispatch(setPrenotaNewDate({ date: selectedDate, startTime: newDate, endTime: selectedEndTime }));
            dispatch(incrementRequestVersion());
            dispatch(resetPostazioneSelectedAndInfoPostazione());
        }
    };

    const handleChangeOrarioFine = (newValue) => {
        if (newValue !== null) {
            let newDate = staticDateWithTimeValue(newValue);
            dispatch(setPrenotaNewDate({ date: selectedDate, startTime: selectedStartTime, endTime: newDate }));
            dispatch(incrementRequestVersion());
            dispatch(resetPostazioneSelectedAndInfoPostazione());
        }
    };

    const handleBlurOrarioInizio = () => {
        const rounded = roundTimeToStep(selectedStartTime);
        if (rounded !== null) handleChangeOrarioInizio(rounded);
    };

    const handleBlurOrarioFine = () => {
        const rounded = roundTimeToStep(selectedEndTime);
        if (rounded !== null) handleChangeOrarioFine(rounded);
    };

    function roundTimeToStep(value, step = 5) {
        const date = new Date(value);
        if (isNaN(date.getTime())) return null;

        const minutes = date.getMinutes();
        const roundedMinutes = Math.round(minutes / step) * step;

        if (roundedMinutes === minutes && date.getSeconds() === 0) return null;

        const rounded = new Date(date.getTime());
        rounded.setHours(date.getHours(), 0, 0, 0);
        rounded.setMinutes(roundedMinutes);

        if (rounded.getDate() !== date.getDate()) rounded.setTime(new Date(date.getTime()).setHours(23, 55, 0, 0));

        return rounded;
    }

    function staticDateWithTimeValue(newValue) {
        let hours = new Date(newValue).getHours();
        let minutes = new Date(newValue).getMinutes();
        let date = new Date(null);
        return new Date(date.setHours(hours, minutes)).toString();
    }


    return (
        <AppBar position="sticky" className="header-prenota-new-appbar">
            <Toolbar variant="dense" className="header-prenota-new-toolbar">
                <Box className="header-prenota-new-title-container">
                    <Typography variant="h6" component="div" className="header-prenota-new-title">
                        {t("Booking")}
                    </Typography>
                </Box>
            </Toolbar>
            
            {/* Sezione per i filtri di Data e Ora + Suggerimenti */}
            <Box className="header-prenota-new-filters-container">
               <Grid container spacing={3} alignItems="center">
                    <Grid item xs={6} sm={4} md={1.8}>
                        <GeneralCustomDateTimePicker
                            TypeTimePicker={5}
                            label={t("Booking_date")}
                            valueStart={selectedDate}
                            handleChange={handleChangeData}
                            minDate={now}
                            maxDate={maxday}
                        />
                    </Grid>
                    <Grid item xs={3} sm={4} md={1.2}>
                         <GeneralCustomDateTimePicker
                            TypeTimePicker={1}
                            label={t("Start_time")}
                            valueStart={selectedStartTime}
                            handleChange={handleChangeOrarioInizio}
                            handleBlur={handleBlurOrarioInizio}
                        />
                    </Grid>
                    <Grid item xs={3} sm={4} md={1.2}>
                         <GeneralCustomDateTimePicker
                            TypeTimePicker={1}
                            label={t("End_time")}
                            valueStart={selectedEndTime}
                            handleChange={handleChangeOrarioFine}
                            handleBlur={handleBlurOrarioFine}
                        />
                    </Grid>
                    
                    {/* Suggerimenti visibili solo nello step edifici (step 0) */}
                    {currentStep === 0 && (
                        <Grid item xs={12} md={7.8}>
                            <Box className="header-prenota-new-tips-container">
                                { !isMobile && <Typography variant="caption" className="header-prenota-new-tips-label">
                                    {t("Tips")}:
                                   </Typography>
                                }
                                <Box className="header-prenota-new-tips-wrapper">
                                    <PannelloSuggerimentiPrenotazioneNew showSuggerimenti={true} />
                                </Box>
                            </Box>
                        </Grid>
                    )}
               </Grid>
            </Box>
        </AppBar>
    );
}
